/**
 * 브라우저 history 와 React Navigation 동기화 — 브라우저 뒤로/앞으로 가기 동작
 */
import { LinkingOptions } from '@react-navigation/native';

const linking: LinkingOptions<any> = {
  prefixes: ['/'],
  config: {
    initialRouteName: 'Main',
    screens: {
      Login: 'login',
      Main: {
        screens: {
          Members: 'members',
          Management: 'management',
          Groups: 'groups',
          Repeater: 'repeater',
          RepeaterSetup: 'repeater-setup',
          Sensor: 'sensor',
          SensorUse: 'sensor-use',
          PushAlram: 'push-alarm',
          Notice: 'notice',
          CaregiverPushAlarm: 'caregiver-push-alarm',
          Analysis: 'analysis',
          SensorScreen: 'sensor-screen',
          Diaper: 'diaper',
          DiaperViewer: 'diaper-viewer',
          DiaperEditRequests: 'diaper-edit-requests',
          CustomerInquiry: 'inquiry',
          FAQ: 'faq',
        },
      },
      ChangePW: 'change-password',
      MemberDetail: 'member/:id?',
      GroupDetail: 'group/:area?',
      Setting: 'setting',
      RepeaterDetail: 'repeater-detail/:id?',
      SensorDetail: 'sensor-detail/:id?',
      SensorHistory: 'sensor/:sensorID/history',
      SensorAnalysis: 'sensor/:sensorID/analysis',
      SensorUseDetail: 'sensor-use-detail/:id?',
      AnalysisDetail: 'analysis-detail/:id?',
      SensorScreenDetail: 'sensor-screen-detail/:area?',
    },
  },
};

export default linking;
